import { Laugh, Users, Brain, Building2, MessageSquare, Star } from "lucide-react";
import { motion } from "framer-motion";

const benefits = [
  { title: "Integracja zespołu", description: "Wspólny śmiech zbliża ludzi i buduje silniejsze relacje w zespole", icon: Users },
  { title: "Redukcja stresu", description: "Humor to najlepszy sposób na rozładowanie napięcia w pracy", icon: Brain },
  { title: "Pozytywny wizerunek", description: "Pokazujesz, że Twoja firma dba o dobrą atmosferę", icon: Building2 },
  { title: "Wzrost produktywności", description: "Zrelaksowani pracownicy są bardziej efektywni i kreatywni", icon: Star },
  { title: "Lepsza komunikacja", description: "Humor pomaga przełamać bariery i ułatwia komunikację", icon: MessageSquare },
  { title: "Niezapomniane wspomnienia", description: "Tworzymy momenty, które na długo pozostaną w pamięci", icon: Laugh },
];

export const Benefits = () => {
  return (
    <section id="benefits" className="py-24 bg-white relative">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-accent font-semibold text-sm tracking-widest uppercase">Korzyści</span>
          <h2 className="text-4xl md:text-5xl font-montserrat font-bold mt-3 text-primary">
            Dlaczego warto?
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6">
          {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return (
              <motion.div
                key={benefit.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.08 * i }}
                className="p-8 rounded-2xl border border-gray-100 hover:border-accent/20 transition-all duration-500 group hover:shadow-lg hover:shadow-accent/5"
              >
                <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center mb-5 group-hover:bg-accent transition-colors duration-300">
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-montserrat font-bold mb-2 text-primary">{benefit.title}</h3>
                <p className="text-gray-500 leading-relaxed">{benefit.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
